import { VContainer } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,{attrs:{"fluid":""}},[[_c('h1',[_vm._v("Bases")]),_c('router-view')]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }